import { Route } from '../../../config/router'
import { checkoutErrors, ConsumerAccountResponse, CrossRegionRedirection, Checkout } from '../../../model'
import { checkCrossBorder, setCheckoutError } from '../../../state'
import { isShadowAccount } from '../../convergence'
import { InitialiseNextRoute } from './types'

interface PersistentLoginParams {
  account: ConsumerAccountResponse
  checkout: Checkout
}

export const determinePersistentLoginRoute = async (params: PersistentLoginParams, dispatch: any): Promise<InitialiseNextRoute | CrossRegionRedirection> => {
  const { account, checkout } = params

  const redirect = await dispatch(checkCrossBorder(account.countryCode, account.email))

  if (redirect !== null && 'error' in redirect && redirect.error === checkoutErrors.unsupported_merchant_trading_country) {
    dispatch(setCheckoutError(redirect))
    return { route: Route.ENTER_EMAIL }
  }

  return redirect !== null
    ? redirect
    : {
        route: Route.LOGGED_IN,
        persistentLogin: true,
        lookup: {
          existing: !isShadowAccount(account.uuid),
          email: account.email,
          merchantId: checkout.merchant.id,
          shadowAccountExists: isShadowAccount(account.uuid),
        },
      }
}
